import "@assets/css/views/Login/style.css";
import "@assets/css/views/Login/responsive/responsive.css";

import { useEffect } from "react";
import Loader from "@helpers/loader/loader";
import localStorageItemNames from "@helpers/localStorage/localStorageItemNames";
import { validateTokenExpiry } from "@helpers/httpRequests/httpRequestsUsuarios/httpRequestsUsuarios";
import { IniciarSesion } from "@components/general/Login/IniciarSesion/IniciarSesion";

import { Card, Col, Container, Image, Row } from "react-bootstrap";
import { Animated } from "react-animated-css";
import React, { useCallback, useState } from "react";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

const particlesOptions = {
	fpsLimit: 60,
	particles: {
		number: {
			value: 100,
			density: {
				enable: true,
			},
		},
		color: {
			value: ["#ffcc00", "#ffffff", "#ff9900"],
		},
		opacity: {
			value: { min: 0.1, max: 0.6 },
		},
		size: {
			value: { min: 1, max: 3 },
		},
		move: {
			enable: true,
			speed: 4,
			random: false,
		},
	},
	interactivity: {
		detectsOn: "window",
		events: {
			onClick: {
				enable: true,
				mode: "push",
			},
			resize: true,
		},
	},
	background: {
		image: "url('https://globalclickmexico.com/img/loginNuevo.webp')",
		position: "50% 50%",
		size: "cover",
		repeat: "no-repeat",
	},
};

const Login = ({ history, location }) => {
	const [showLoader, setShowLoader] = useState(true);

	useEffect(() => {
		const validarExpiracionToken = async () => {
			try {
				const token = localStorage.getItem(localStorageItemNames.token);

				if(!token){
					return;
				}

				await validateTokenExpiry(token);

				history.replace("/dashboard");
			} catch (error) {
				setTimeout(() => {
					setShowLoader(false);
				}, 1800);
			}
		};

		validarExpiracionToken();

		setTimeout(() => {
			setShowLoader(false);
		}, 1800);

	}, []);

	const particlesInit = useCallback(async (engine) => {
		await loadFull(engine);
	}, []);

	return (
		<>
			{showLoader && <Loader />}

			{!showLoader && (
				<>
					<Particles options={particlesOptions} init={particlesInit} id="tsparticles" />

					<Animated animationIn="fadeIn" isVisible={true} className="vh-100">
						<div id="particles" className="h-100">
							<Container className="d-flex h-100 justify-content-center flex-column align-items-center">
								<Card style={{background: 'none'}} className="w-100 border-0">
									<Row className="g-0 d-flex justify-content-between">
										<Col lg="6" className="d-none d-lg-block">
											<Image src={require("@assets/images/logoGCvertical.png")} className="rounded-start w-100 img-login" style={{height: "100%"}} />
										</Col>

										<Col xs={12} lg="6">
											<Card.Body className="d-flex flex-column h-100">
												<IniciarSesion />
											</Card.Body>
										</Col>
									</Row>
								</Card>
							</Container>
						</div>
					</Animated>
				</>
			)}
		</>
	);
};

export default Login;
